import { FC, useMemo } from 'react';
import { defaultFn } from 'constants/index';
import { Tabs } from 'destiny';
import { MenuItem } from 'types';
import { trackMixpanel } from 'utils/mixpanel';

const TabsWidget: FC<any> = ({
  schema: { enum: enumList = [], default: defaultValue = null } = {},
  name = '',
  options: { schemaId = '' } = {},
  onChange = defaultFn,
}) => {
  const handleSelect = ({ value: selectedValue }: any) => {
    onChange(selectedValue);
  };

  const list = useMemo(
    () =>
      enumList?.reduce((acc: Array<{ label: string; value: string }>, { id, value }: { id: string; value: string }) => {
        acc.push({
          label: value,
          value: id,
        });

        return acc;
      }, []),
    [enumList]
  );

  return list?.length > 1 ? (
    <Tabs
      list={list}
      onSelect={handleSelect}
      customSelectedIndex={list?.findIndex((e: MenuItem) => e?.value === defaultValue) || 0}
      tabItemWrapperStyle='!tw-w-1/2'
      tabItemGapClassName='tw-mr-0'
      id={`${schemaId?.toUpperCase()}_${name?.toUpperCase()}_TABS`}
      eventCallback={trackMixpanel}
    />
  ) : null;
};

export default TabsWidget;
